import React, { Component, createRef } from "react";
import moment from "moment/moment";
// // Editable
import { withTranslation } from "react-i18next";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import { Card, Col, Container, Row } from "reactstrap";

import { Link } from "react-router-dom";
import { getStocksDashboard, baseUrl, getExpressInwardApi } from "api";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";

class ExpressDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      editRowIndex: -1,
      inwordStockList: [],
      dashboardInfo: "",
    };
  }

  async componentDidMount() {

    const data = await getExpressInwardApi({ page: 1, limit: 5 });

    console.log('dsss',data);
    
    // const data = await getStockInward({ page: 1, limit: 5 });
    if (data && data.data) {
      this.setState({
        inwordStockList:
        data.data?.expressInwards?.length == 0
            ? [
                {
                  id: "0",
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : data.data.expressInwards,
      });
    }
    const dashboard = await getStocksDashboard();
    if (dashboard && dashboard.data) {
      this.setState({
        dashboardInfo: dashboard.data,
      });
    }
  }

  render() {
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
      },
      {
        dataField: "jangadId",
        text: `${this.props.t("Jangad Id")}`,
        formatter(cell, row) {
          return row.jangadId;
        },
        sort: true,
      },
      {
        dataField: "partyId",
        text: `${this.props.t("Party Id")}`,
        formatter(cell, row) {
          return row.party.name;
        },
        sort: true,
      },
      {
        dataField: "noOfPieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
      },
      {
        dataField: "totalWeight",
        text: `${this.props.t("Weight")}`,
        sort: true,
      },
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        sort: true,
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      // Add more columns as needed
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => (
            <>
              <div className="btn-group">
              {row.status === 'Pending' && (
                <Link
                  to={{
                    pathname: "/user-add-express-inward",
                    query: {
                      isEdit: 2,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded">
                    <img src="images/dashboard-images/edit.svg" />
                  </button>
                </Link>
              )}
                <Link
                  to={{
                    pathname: "/user-add-express-inward",
                    query: {
                      isEdit: 3,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 ms-2 border-0 rounded">
                    <img src="images/dashboard-images/view.svg" />
                  </button>
                </Link>
              </div>
            </>
          ),
      },
    ];

    document.title = "sales office";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Row>
              <Breadcrumbs breadcrumbItem={this.props.t("Dashboard")} />
              <Col xxl={2} lg={3}>
                <div className="bg-light-purple position-relative main_hero_section main_hero_section_sub py-lg-5 py-0">
                  <Row className="ps-2">
                    <Col sm={8}>
                      <div className="pt-1">
                        <h3 className="text-black">
                          {this.props.t("Welcome Back")} !
                        </h3>
                      </div>
                    </Col>
                    <Col sm={4}>
                      <img
                        src={
                          JSON.parse(localStorage.getItem("authUser")).photo ==
                          null
                            ? "images/dashboard-images/welcome.svg"
                            : `${baseUrl}/uploads/${
                                JSON.parse(localStorage.getItem("authUser"))
                                  .photo
                              }`
                        }
                        className="img-fluid mt-3"
                        alt="welcome image"
                      />
                    </Col>
                    <p className="text-secondary">
                      {JSON.parse(localStorage.getItem("authUser")).name}
                    </p>
                  </Row>
                  <div className="bg-white main_hero_section_sub w-100 mt-2 absolute ms-0 py-4 px-2">
                    <h4 className="text-black">
                      {this.props.t("User Dashboard")}
                    </h4>
                    <Link to="/profile">
                      {" "}
                      <button className="main_hero_section_sub_btn mt-3">
                        View Profile{" "}
                        <i className="fa-solid fa-arrow-right-long"></i>
                      </button>
                    </Link>
                  </div>
                </div>
              </Col>
              {/* <Col xxl={2} lg={3}>
                <div className="bg-light-purple main_hero_section py-3 px-2">
                  <Row>
                    <Col sm={8}>
                      <div className="pt-4">
                        <h3 className="text-black">
                          {this.props.t("Welcome Back")}
                        </h3>
                      </div>
                    </Col>
                    <Col sm={4}>
                      <img
                        src={JSON.parse(localStorage.getItem("authUser")).photo == null ? "images/dashboard-images/welcome.svg" : `${baseUrl}/uploads/${JSON.parse(localStorage.getItem("authUser")).photo}`}
                        className="img-fluid mt-3"
                        alt="welcome image"
                      />
                    </Col>
                    <p className="text-secondary">
                      {JSON.parse(localStorage.getItem("authUser")).name}
                    </p>
                  </Row>
                </div>
                <div className="bg-white main_hero_section_sub py-3 px-2">
                  <h4 className="text-black">
                    {this.props.t("User Dashboard")}
                  </h4>
                  <Link to="/profile">
                    {" "}
                    <button className="main_hero_section_sub_btn mt-3">
                      View Profile{" "}
                      <i className="fa-solid fa-arrow-right-long"></i>
                    </button>
                  </Link>
                </div>
              </Col> */}
              <Col xxl={10} lg={9}>
                <Row>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Daily Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.dailyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Daily Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.dailyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Weekly Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.weeklyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Weekly Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.weeklyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Monthly Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.monthlyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Monthly Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.monthlyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Yearly Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.yearlyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Yearly Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.yearlyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("EXPRESS INWARD")}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    data={this.state.inwordStockList}
                    columns={this.columns1}
                  />
                </div>
              </Card>
            </div>

            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("EXPRESS OUTWARD")}
                </h2>
              </div>
              {/* <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    expandRow={expandRow1}
                    data={this.state.inwordStockList}
                    columns={this.columns1}
                  />
                </div>
              </Card> */}
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(ExpressDashboard);
